module.exports = __webpack_public_path__ + "img/ic-linechart-grey.fbbba3a3.svg";